<template>
  <section class="pd-y-10">
    <!-- style="max-width: 600px !important" -->
    <div class="container" style="padding-bottom: 0px; padding-top: 20px;">
      <div class="section-title" style="text-align:left;">
        <h2>{{ comp.task }}</h2>
        <!-- <p class="mg-b-0">{{comp.f1}}</p> -->
      </div>
    </div>
    <div class="container mg-b-10" style="padding-top: 0px;">
      <div class="row">
        <div
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
          v-for="(c, i) in types"
          :key="i"
          role="button"
        >
          <div class="card bg-dark ht-150 overflow-hidden">
            <router-link
              v-if="$store.state.app.pages.filter(x => x.st1 == 'courses').length"
              :to="{
                name: $store.state.app.activeGroup.publicPage.route,
                params: {
                  id: $store.state.app.pages.filter(x => x.st1 == 'courses')[0]
                    .id,
                  cid: c.id
                }
              }"
            >
              <img
                v-if="c.field1 != null && c.field1 != ''"
                class="card-img-top op-2"
                :src="`${c.field1}?w=400&h=250&mode=crop`"
              />
              <img
                v-else
                class="card-img-top op-1"
                src="assets/img/course-type.jpg"
              />
              <div
                class="card-img-overlay d-flex align-items-center text-center"
              >
                <div class="wd-100p">
                  <h4 class="card-title text-white lh-1">{{ c.s1 }}</h4>
                  <p class="card-text text-white">
                    Нийт {{ c.courseCount }} хичээл
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    comp: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      types: []
    };
  },
  mounted() {
    this.loadTypes();
  },
  methods: {
    loadTypes() {
      request({
        api: { method: "GET", url: "type/getData" },
        params: {
          key: "courseType"
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.types;
          if (res.data.types.length > 12) {
            this.types = res.data.types.filter(x => x.courseCount > 0);
          }
          console.log('type/getData=> ', res);
        }
      });
    }
  }
};
</script>

<style></style>
